const NoPage = () => {
  return <h1>404 No Page Found</h1>;
};

export default NoPage;
